import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(sync);

import { isAsyncIterable, isIterable } from "../_internal/utils.js";
import concurrent, { isConcurrent } from "./concurrent.js";

function sync(a, iterable) {
  return _regeneratorRuntime.wrap(function sync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield(iterable, "t0", 1);

        case 1:
          _context.next = 3;
          return a;

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function asyncSequential(a, iterable) {
  var _ref;

  var iterator = iterable[Symbol.asyncIterator]();
  var finished = false;
  return _ref = {}, _defineProperty(_ref, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_ref, "next", function next() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$iterator$next, value, done;

      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!finished) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", {
                done: true,
                value: undefined
              });

            case 2:
              _context2.next = 4;
              return iterator.next();

            case 4:
              _yield$iterator$next = _context2.sent;
              value = _yield$iterator$next.value;
              done = _yield$iterator$next.done;

              if (!finished) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", {
                done: true,
                value: undefined
              });

            case 9:
              if (!done) {
                _context2.next = 17;
                break;
              }

              finished = true;
              _context2.next = 13;
              return a;

            case 13:
              _context2.t0 = _context2.sent;
              return _context2.abrupt("return", {
                done: false,
                value: _context2.t0
              });

            case 17:
              return _context2.abrupt("return", {
                done: done,
                value: value
              });

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee);
    }))();
  }), _ref;
}

function async(a, iterable) {
  var _ref2;

  var iterator = null;
  return _ref2 = {}, _defineProperty(_ref2, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_ref2, "next", function next(_concurrent) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (iterator === null) {
                iterator = isConcurrent(_concurrent) ? asyncSequential(a, concurrent(_concurrent.length, iterable)) : asyncSequential(a, iterable);
              }

              return _context3.abrupt("return", iterator.next(_concurrent));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee2);
    }))();
  }), _ref2;
}

function append(a, iterable) {
  if (iterable === undefined) {
    return function (iterable) {
      return append(a, iterable);
    };
  }

  if (isAsyncIterable(iterable)) {
    return async(a instanceof Promise ? a : Promise.resolve(a), iterable);
  }

  if (isIterable(iterable)) {
    return sync(a, iterable);
  }

  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}

export default append;